<template>
    <div>
        <canvas :id="id"></canvas>
    </div>
</template>
<script type="text/babel">
    export default {
        props   : [
            'id',
            'options',
            'type'
        ],
        data() {
            return {
                chart: null,
            }
        },
        computed: {},
        watch   : {},
        mounted() {
            this.initChart();
        },
        methods : {
            updateChart( { dataSets, labels } ) {
                this.chart.data = {
                    datasets: dataSets,
                    labels  : labels
                };

                this.chart.update();
            },
            initChart() {
                let plugin = {
                    afterDraw: function ( chart ) {
                        if ( chart.data.datasets && chart.data.datasets[ 0 ] && chart.data.datasets[ 0 ].data.length === 0 ) {
                            let ctx = chart.chart.ctx;
                            chart.clear();

                            ctx.save();
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.fillText( 'No data to display', chart.chart.width / 2, chart.chart.height / 2 );
                            ctx.restore();
                        }
                    }
                };

                this.chart = new Chart( $( '#' + this.id ), {
                    plugins: [ plugin ],
                    type   : this.type,
                    options: this.options
                } );
            },
        }
    }
</script>